export enum BackendType {
	Development = "development",
	Stage = "stage",
	Production = "production",
}
